import { Button, Grid } from "@aws-amplify/ui-react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import LocalizedStrings from "react-localization";
import { API, graphqlOperation } from "aws-amplify";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";

import ItemListCollection from "../ItemListCollection";
import { equipmentByBranchID } from "graphql/queries";

export const EquipmentsChoose = ({
  initEquipmentsGranted = [],
  onChangeEquipmentsGranted,
  resetValues,
  branch,
}) => {
  const [equipmentsAvailable, setEquipmentsAvailable] = useState([]);
  const [equipmentsGranted, setEquipmentsGranted] = useState([]);
  const [equipmentsAvailableSelected, setEquipmentsAvailableSelected] =
    useState([]);
  const [equipmentsGrantedSelected, setEquipmentsGrantedSelected] = useState(
    []
  );
  const [keywordEquipmentsGranted, setKeywordEquipmentsGranted] = useState("");
  const [loading, setLoading] = useState(false);

  async function fetchEquipmentsAvailable(keyword, diffEquipments, branchID) {
    try {
      setLoading(true);
      const equipmentsData = await API.graphql(
        graphqlOperation(equipmentByBranchID, {
          limit: 500,
          filter: keyword
            ? {
                or: [
                  {
                    name: { contains: keyword },
                  },
                ],
                deletedAt: { attributeExists: false },
              }
            : { deletedAt: { attributeExists: false } },
          branchID,
        })
      );
      const equipmentsItems = equipmentsData.data.equipmentByBranchID.items;
      const equipmentsGrantedExist = equipmentsItems?.filter((equipmentItem) =>
        diffEquipments?.some((diffUs) => diffUs.id === equipmentItem.id)
      );

      setEquipmentsGranted(equipmentsGrantedExist);
      setEquipmentsAvailable(
        equipmentsItems
          ?.filter(
            (equipmentItem) =>
              !equipmentsGrantedExist?.some(
                (diffUs) => diffUs.id === equipmentItem.id
              )
          )
          ?.map((equipmentItem) => ({
            id: equipmentItem.id,
            name: equipmentItem.name,
          }))
      );
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (branch) {
      fetchEquipmentsAvailable(undefined, initEquipmentsGranted, branch);
    } else {
      setEquipmentsGranted([]);
      setEquipmentsAvailable([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initEquipmentsGranted, resetValues, branch]);

  useEffect(() => {
    if (onChangeEquipmentsGranted) onChangeEquipmentsGranted(equipmentsGranted);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [equipmentsGranted]);

  const cleanSelected = () => {
    setEquipmentsAvailableSelected([]);
    setEquipmentsGrantedSelected([]);
  };

  const setInAvailable = (items) => {
    if (!items || items?.length <= 0) return
    setEquipmentsAvailable((prevSt) => [...prevSt, ...items]);
    setEquipmentsGranted((prevSt) =>
      prevSt.filter(
        (prev) => !items?.some((equipment) => equipment.id === prev.id)
      )
    );
    cleanSelected();
  };

  const setInGranted = (items) => {
    if (!items || items?.length <= 0) return
    setEquipmentsGranted((prevSt) => [...prevSt, ...items]);
    setEquipmentsAvailable((prevSt) =>
      prevSt.filter(
        (prev) => !items?.some((equipment) => equipment.id === prev.id)
      )
    );
    cleanSelected();
  };

  const onSearchEquipmentsGranted = (keyword) => {
    setKeywordEquipmentsGranted(keyword);
  };

  return (
    <Grid templateColumns={{ base: "1fr", large: "2fr 1fr 2fr" }} gap="30px">
      <div>
        <div className="fs-5 mb-3">{strings.equipments.available}</div>
        <ItemListCollection
          items={equipmentsAvailable}
          selectedItems={equipmentsAvailableSelected}
          setSelectedItems={setEquipmentsAvailableSelected}
          onSearchSubmit={(keyword) =>
            fetchEquipmentsAvailable(keyword, equipmentsGranted, branch)
          }
          loading={loading}
        />
      </div>
      <div style={styles.containerButtons}>
        <Button
          style={styles.buttonActions}
          onClick={() => setInAvailable(equipmentsGrantedSelected)}
        >
          <IoIosArrowBack />
        </Button>
        <Button
          style={styles.buttonActions}
          onClick={() => setInAvailable(equipmentsGranted)}
        >
          <IoIosArrowBack />
          <IoIosArrowBack />
        </Button>
        <Button
          style={styles.buttonActions}
          onClick={() => setInGranted(equipmentsAvailableSelected)}
        >
          <IoIosArrowForward />
        </Button>
        <Button
          style={styles.buttonActions}
          onClick={() => setInGranted(equipmentsAvailable)}
        >
          <IoIosArrowForward />
          <IoIosArrowForward />
        </Button>
      </div>
      <div>
        <div className="fs-5 mb-3">{strings.equipments.granted}</div>
        <ItemListCollection
          items={
            keywordEquipmentsGranted
              ? equipmentsGranted.filter((equipmentGr) =>
                  equipmentGr.name
                    .toLowerCase()
                    .includes(keywordEquipmentsGranted?.toLowerCase())
                )
              : equipmentsGranted
          }
          selectedItems={equipmentsGrantedSelected}
          setSelectedItems={setEquipmentsGrantedSelected}
          onSearchSubmit={onSearchEquipmentsGranted}
        />
      </div>
    </Grid>
  );
};

const strings = new LocalizedStrings({
  es: {
    equipments: {
      available: "Equipos disponibles",
      granted: "Equipos asociados",
    },
    responses: {
      errorFetch: "Error al consultar equipos",
    },
  },
});

const styles = {
  containerButtons: {
    display: "flex",
    justifyContent: "center",
    flexFlow: "column",
    gap: "10px",
  },
  buttonActions: {
    width: "65px",
    alignSelf: "center",
  },
};

export default EquipmentsChoose;
